export default "__VITE_ASSET__BANlM3cm__"